import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import * as Api from '../../common/Api';
import {parseCubeFilter, parseDynamicCubeFilter, parseDimension} from "./CubeFilterBuilder";
import config from "../../config";

const initialState = {
    status: {
        status: 'idle',
        error: undefined,
    },
    searchCriteria: [],
};

export const saveSearchCriteria = createAsyncThunk('toolbeltdata/saved-search-criteria',
    async ({name, type, description, filters, cubeNamespace}) => {
    if (!type || !name) {
        throw new Error('required field.');
    }
        // Match the live query (universeQuerySlice.prepareFilters): schema-driven
        // filters go through parseDynamicCubeFilter, legacy filters through
        // parseCubeFilter. Running dynamic filters (e.g. NAICS/SIC with a
        // schemaProperty + operatorOverride) through parseCubeFilter stringifies
        // their value objects to "[object Object]" and uses the raw id as the
        // member, producing a query that can't be reloaded onto the explore page.
        const allFilters = filters && filters.length > 0 ? filters : [];
        const dynamicInput = allFilters.filter(f => f.schemaProperty);
        const legacyInput = allFilters.filter(f => !f.schemaProperty);
        const _filters = [
            ...parseDynamicCubeFilter(dynamicInput, cubeNamespace),
            ...(legacyInput.length > 0 ? parseCubeFilter(legacyInput) : []),
        ];
        const _dimensions = parseDimension(type, cubeNamespace);
        const requestUrl = `${config.services.ATLAS.apiUrl}/saved-searches`;
        const data = {
            data: {
                name: name,
                description: description || '',
                type: type,
                query: {
                    type: type,
                    requestUrl: requestUrl,
                    requestQuery: {
                        dimensions: _dimensions,
                        filters: _filters,
                        ungrouped: true,
                    },
                    filters: {
                        value: filters,
                        version: 0.1,
                    },
                }
            }
        };
        const resultSet = await Api.post(true,
            requestUrl,
            data
        );
        return resultSet;

});

export const findSearchCriteria = createAsyncThunk('toolbeltdata/get-search-criteria',
    async ({where, offset, limit}) => {
        const filter = {
            filter: {
                where: where,
                order: ['updated DESC'],
                limit,
                skip: offset
            }
        };
        const requestUrl = `${config.services.ATLAS.apiUrl}/saved-searches`;
        const resultSet = await Api.get(true,
            requestUrl,
            filter
        );
        return resultSet;

    });


const searchDataSlice = createSlice({
    name: 'searchData', initialState,
    reducers: {
        reset: {
            reducer(state, action) {
                state.status.status = 'idle';
                state.status.error = '';
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(saveSearchCriteria.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(saveSearchCriteria.fulfilled, (state, action) => {
                state.status.status = 'succeeded';
                if (action.payload) {
                    state.searchCriteria = [action.payload, ...state.searchCriteria];
                }
            })
            .addCase(saveSearchCriteria.rejected, (state, action) => {
                state.status.status = 'failed';
                state.status.error = action?.error?.message;
            })
            .addCase(findSearchCriteria.pending, (state, action) => {
                state.status.status = 'loading';
            })
            .addCase(findSearchCriteria.fulfilled, (state, action) => {
                state.searchCriteria = action.payload;
                state.status.status = 'succeeded';
            })
            .addCase(findSearchCriteria.rejected, (state, action) => {
                state.status.status = 'failed';
                state.status.error = action?.error?.message;
            });
    }
});


export const {reset, } = searchDataSlice.actions;
export default searchDataSlice.reducer;
